document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-ap-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-ap-track]');
    var prevBtn = slider.querySelector('[data-ap-prev]');
    var nextBtn = slider.querySelector('[data-ap-next]');
    if (!track) return;

    function slideWidth() {
      var slide = track.querySelector('.ap-slide');
      return slide ? slide.getBoundingClientRect().width : track.clientWidth;
    }

    prevBtn && prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
    });

    nextBtn && nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
    });
  });
});
